module.exports = __webpack_public_path__ + "img/pesaj-2016-thumbnail.3f21df55.jpg";